export default {"src":"/_next/static/media/qash.303d46a6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};